export default "__VITE_ASSET__948a4b62__"